import { useAuth } from "@/providers";
import { AssociationFileBrowser } from "@/shared/components/AssociationFileBrowser";
import { Goto } from "@/shared/navigation";

/**
 * Assets tab of Settings: a file browser over the files associated with the
 * organization itself (association ID is the org ID) rather than with one of
 * its datasets or devices.
 */
export function OrganizationAssets() {
  const { currentOrganization } = useAuth();

  if (!currentOrganization) {
    return null;
  }

  return (
    <AssociationFileBrowser
      associationId={currentOrganization.org_id}
      orgId={currentOrganization.org_id}
      rootUrl={Goto.route.Settings.Assets}
      rootLabel="Assets"
      parentCrumbs={[]}
    />
  );
}
